import React, { useEffect, useState } from "react";
import FormStrip from "../../components/FormStrip";
import HeaderContent from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import { useTranslation } from "react-i18next";
import { PortalWrapper, SideWrapper, MainWrapper } from "../../components/StyledComponent";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import { BackButton, Loader } from "@egovernments/digit-ui-react-components";
import { useHistory, useLocation } from "react-router-dom";
import { Sidebarlabels } from "../../components/data";
import SubStep1 from "./Step1/SubStep1";
import useDepartmentSelector from "../../../TCPForms/hooks/useDepartmentSelector";
import getMapSubmissionData from "../map-submission/getMapSubmissionData";
import { ScrutinyUnderProcess } from "../../reusableComponents/ScrutinyLoader";

const PlinthPortal = () => {
  const dispatch = useDispatch();
  const { initFormMTDocs, resetFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const { t } = useTranslation();
  const tenantId = Digit.ULBService.getStateId();
  const { id } = useParams();
  const history = useHistory();
  const location = useLocation();
  const [, applicationFlow] = useDepartmentSelector();
  const [selectedSubTab, setSelectedSubTab] = useState(0);
  const [activeTab, setActiveTab] = useState(0);
  const [proposedSite, setProposedSite] = useState(null);
  const { applicationData, isAppDataLoading } = getMapSubmissionData(t, id);
  const { info: userInfo } = Digit.UserService.getUser();
  const Modal = useModal();
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_MAP_PLINTH", applicationData);

  const {
    data: { LandUseMasterData: { Authorities: schemeTypeData } = {} } = {},
    isLoading: schemeTypeDataLoading,
  } = Digit.Hooks.obps.useMDMS(tenantId, "LandUseMasterData", ["Authorities"]);
  const {
    data: { PrimaryUseMasterData: { ProposedActivity: nonSchemeTypeData } = {} } = {},
    isLoading: nonSchemeTypeDataLoading,
  } = Digit.Hooks.obps.useMDMS(tenantId, "PrimaryUseMasterData", ["ProposedActivity"]);

  useEffect(() => {
    Digit.SessionStorage.get("FILE_NO");
    Digit.SessionStorage.get("OWNER_INFO");
  }, []);
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({ ...data });
    } else {
      setParams({ ...params, ...{ [key]: { ...params[key], ...data } } });
    }
  };

  const handleTabChange = (nextTab, formData = null) => {
    if (nextTab === 1 && formData) {
      const data = { ...params, ...formData };

      const additionalLandInfo = data?.additionalDetails?.landInfo;

      if (additionalLandInfo) {
        data.landInfo = {
          ...data.landInfo,

          // Add tenantId only if missing
          tenantId: data.landInfo?.tenantId ? data.landInfo?.tenantId : additionalLandInfo?.tenantId,

          // Add address only if missing
          address: data.landInfo?.address ? data.landInfo?.address : additionalLandInfo?.address,
        };
      }
      data.workflow.action = "APPLY_TO_DEPARTMENT";
      (data.applicationType = "FORM_PLINTH"), (data.oldMapSubApplNumber = data.applicationNo);
      delete data.applicationNo;
      Digit.OBPSService.create({ BPA: data }, tenantId)
        .then((res) => {
          if (res?.BPA?.length > 0) {
            Modal("Application Created", `Application Created Successfully!`, "success");
          }
          history.push("/digit-ui/citizen/obps/plinthApplications");
        })
        .catch((e) => {
          Modal("Error", `${e?.response?.data?.Errors[0]?.message}`, "error");
        });
    } else {
      const data = { ...params, ...formData };
      try {
        data.workflow = { action: "UPLOAD_DOC", assignes: null };
        updateApiCall.mutate(
          { BPA: data },
          {
            onSuccess: (res) => {
              onSelect("", res?.BPA?.[0]);
              Modal("Application Updated", `Application Updated Successfully!`, "success");
              Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
            },
            onError: () => {
              Modal("Update Error", "Something went wrong!!", "error");
            },
          }
        );
      } catch (error) {
        console.error(error);
        Modal("Update Error", "Something went wrong!!", "error");
      }
    }
  };

  useEffect(() => {
    if (id && applicationData) {
      setParams(applicationData);
      if (applicationData?.documents?.length > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, applicationData]);

  const renderContent = () => {
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return (
            <SubStep1
              formData={params}
              userInfo={userInfo}
              handleTabChange={handleTabChange}
              setProposedSite={setProposedSite}
              schemeTypeData={schemeTypeData}
              nonSchemeTypeData={nonSchemeTypeData}
              id={id}
            />
          );
        default:
          return null;
      }
    }
  };

  if (isAppDataLoading || (id && !applicationData)) {
    return <Loader />;
  }
  return (
    <MainWrapper>
      {/* <HeaderContent applicationFlow={applicationFlow} /> */}
      <BackButton />
      <FormStrip formName={"Plinth Submission Form"} />
      {activeTab === 0 && renderContent()}
    </MainWrapper>
  );
};

export default PlinthPortal;
